import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {Select} from '@ngxs/store';
import {PlanState} from '../../models/plan';
import {Observable} from 'rxjs';
import {SubscriptionResponseDTO} from '../../dtos/billing';

@Component({
  selector: 'app-modal-wait-subscription',
  templateUrl: './modal-wait-subscription.component.html',
  styleUrls: ['./modal-wait-subscription.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalWaitSubscriptionComponent implements OnInit {
  @Select(PlanState.getSubscriptionStripe) subscriptionStripe$: Observable<SubscriptionResponseDTO | undefined> | undefined;
  @Output() subscribe: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isVisibleModal: boolean;
  constructor() { }

  ngOnInit(): void {
  }

  onEmitSubscribe(): void {
    this.subscribe.emit();
  }
}
